<template lang="pug">
  .sign-in
    v-card.sign-in__form
      v-toolbar.white(card, prominent)
        v-toolbar-title.light-blue--text.subheading Iniciar sesión
      form.px-3(@keyup.enter='signIn')
        v-text-field(
          v-model='username'
          label='Nombre de usuario'
          required
        )
        v-text-field(
          v-model='password'
          label='Contraseña'
          type='password'
          required
        )
        v-alert(error, :value='error') {{ error }}
      v-btn.sign-in__submit.ma-3(
        flat
        :loading='loading'
        :disabled='loading'
        @click.prevent='signIn'
      ) Sign in
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      username: '',
      password: '',
      error: '',
    };
  },

  computed: {
    ...mapState('auth', { loading: 'isAuthenticatePending' }),
  },

  methods: {
    ...mapActions('auth', ['authenticate']),

    async signIn() {
      const { username, password } = this;

      try {
        await this.authenticate({ strategy: 'local', username, password });
        this.$router.push({ name: 'App' });
      } catch (error) {
        switch (error.message.toLowerCase()) {
          case 'missing credentials': {
            this.error = 'No introdujo usuario o contraseña';
            break;
          }
          case 'invalid login': {
            this.error = 'Usuario o contraseña incorrecto';
            break;
          }
          default: {
            this.error = 'Error desconocido';
          }
        }
        throw error.message;
      }
    },
  },

  watch: {
    username() {
      this.error = '';
    },

    password() {
      this.error = '';
    },
  },
};
</script>

<style lang="less">
.sign-in {
  align-items: center;
  display: flex;
  height: 90vh;
  justify-content: center;

  &__form {
    display: flex;
    flex-direction: column;
    width: 30vw;
  }

  &__submit {
    align-self: flex-end;
    margin-left: auto;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sign-in.vue